import {Skeleton} from "@mui/material"
import {FC} from "react"

type ImageAvatarProps = {
  loading?: boolean
  src: string
  alt?: string
  size: string
}
const ImageAvatar: FC<ImageAvatarProps> = (props) => {
  const {loading, src, alt, size} = props

  return !loading ? (
    <img
      src={src}
      alt={alt}
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        objectFit: "cover",
      }}
    />
  ) : (
    <Skeleton variant="circular" width={size} height={size} />
  )
}

export default ImageAvatar
